import React, { useEffect, useState } from 'react';
import { ValidatedField, ValidatedForm } from 'react-jhipster';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import PasswordStrengthBar from 'app/shared/layout/password/password-strength-bar';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { handlePasswordResetFinish, reset } from '../password-reset.reducer';
import { useTranslation } from 'app/shared/i18n';

export const PasswordResetFinishPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const [password, setPassword] = useState('');
  const successMessage = useAppSelector(state => state.passwordReset.successMessage);

  useEffect(
    () => () => {
      dispatch(reset());
    },
    [],
  );
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      navigate('/login');
    }
  }, [successMessage]);

  const handleValidSubmit = ({ newPassword }) => dispatch(handlePasswordResetFinish({ key, newPassword }));

  if (!key)
    return (
      <div className="ms-auth">
        <div className="ms-auth__card ms-card" style={{ padding: 40, textAlign: 'center' }}>
          <div style={{ fontSize: 40, opacity: 0.3, marginBottom: 10 }}>🔗</div>
          <div style={{ color: '#64748B' }}>{t('passwordReset.linkInvalid')}</div>
        </div>
      </div>
    );

  return (
    <div className="ms-auth">
      <div className="ms-auth__card ms-card">
        <div className="ms-auth__header">
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>{t('passwordReset.finishTitle')}</h2>
        </div>
        <div className="ms-auth__body">
          <ValidatedForm onSubmit={handleValidSubmit}>
            <ValidatedField
              name="newPassword"
              label={t('passwordReset.newPassword')}
              placeholder={t('passwordReset.newPasswordPlaceholder')}
              type="password"
              validate={{
                required: { value: true, message: t('passwordReset.newPasswordRequired') },
                minLength: { value: 4, message: t('passwordReset.newPasswordMinLength') },
              }}
              onChange={e => setPassword(e.target.value)}
              data-cy="resetPassword"
            />
            <PasswordStrengthBar password={password} />
            <ValidatedField
              name="confirmPassword"
              label={t('passwordReset.confirmPassword')}
              placeholder={t('passwordReset.confirmPasswordPlaceholder')}
              type="password"
              validate={{
                required: { value: true, message: t('passwordReset.confirmPasswordRequired') },
                validate: v => v === password || t('passwordReset.confirmPasswordMismatch'),
              }}
              data-cy="confirmResetPassword"
            />
            <button className="ms-btn ms-btn--primary" type="submit" data-cy="submit" style={{ width: '100%', padding: 12 }}>
              {t('passwordReset.saveNewPassword')}
            </button>
          </ValidatedForm>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetFinishPage;
